import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'react-table/react-table.css';
import {debounce} from 'throttle-debounce';
import Table from '../../common/table/TicketTable';
import {fetchSparePartsOrdersHistoryPageData} from '../../../actions/orders/actionSparePartsHistoryPage';
import {Link} from 'react-router-dom';
import moment from 'moment';
import historyMessages from '../../../intl/sparePartsOrders/historyMessages';


class HistoryOrderTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.loadStateFromSessionStorage({
            historySPDefaultPageSize: 10,
            historySPDefaultSort: [{id: "ticketNumber", desc: true}],
            historySPDefaultFilters: [],
        });
        this.filtering = false;
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^historySP*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^historySP*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchSparePartsOrdersHistoryPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            historySPDefaultPageSize: state.pageSize,
            historySPDefaultSort: state.sorted,
            historySPDefaultFilters: state.filtered,
        });
    };

    fetchStrategy = (state) => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'created') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10),
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const { columns, data, pages, isLoading, isNextPage, isNextFromPivot } = this.props;
        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'ticketNumber',
                                    accessor: 'ticketNumber',
                                    message: historyMessages.TABLE_TICKET_NUMBER,
                                    Cell: (row) => <Link to={`view/${row.original.uuid}`}>{row.value}</Link>,
                                },
                                ...columns]}
                            isLoading={isLoading}
                            data={data ? data : []}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.historySPDefaultFilters}
                            defaultSorting={this.state.historySPDefaultSort}
                            defaultPageSize={this.state.historySPDefaultPageSize}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

HistoryOrderTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    pages: PropTypes.number.isRequired,
    fetchSparePartsOrdersHistoryPageData: PropTypes.func.isRequired,
    columns: PropTypes.array,
};

const mapStateToProps = state => ({
    isLoading: state.sparePartsHistoryPage.isTableLoading,
    data: state.sparePartsHistoryPage.listData,
    isNextPage: state.sparePartsHistoryPage.isNextPage,
    isNextFromPivot: state.sparePartsHistoryPage.isNextFromPivot,
    pages: state.sparePartsHistoryPage.pages,
});

export default connect(mapStateToProps, { fetchSparePartsOrdersHistoryPageData })(HistoryOrderTable);
